import { Children } from 'react';
import type { ReactNode } from 'react';

import Stack from '@mui/material/Stack';

interface Props {
  readonly children: ReactNode;
}

// Alerts shown one under the other, from the most to the least important, evenly spaced: the
// stack gives the spacing, the margins of the alerts being neutralized; nothing without alert.
export const AlertStack = ({ children }: Readonly<Props>) =>
  Children.toArray(children).length ? (
    <Stack spacing={2} sx={{ mb: 2 }}>
      {children}
    </Stack>
  ) : null;
